import React from "react";
import "./PartnerProgram.css";

export default function VortexNetworkStudios() {

    return (

        <div className="vortex-partner-page">


            <div className="vortex-partner-container">


                {/* HERO */}

                <section className="vortex-partner-hero">


                    <div>


                        <div className="vortex-partner-badge">

                            🟩 Minecraft Marketplace Partner

                        </div>



                        <h1 className="vortex-partner-title">

                            VortexNetwork

                            <span>
                                Studios
                            </span>

                        </h1>



                        <p className="vortex-partner-description">

                            Join VortexNetwork Studios and help create
                            the next generation of Minecraft Marketplace
                            experiences including worlds, addons,
                            skins, and texture packs.

                        </p>




                        <div className="vortex-partner-buttons">


                            <a
                                className="vortex-partner-btn vortex-partner-btn-primary"
                                href="#apply"
                            >

                                Apply Now

                            </a>




                            <a
                                className="vortex-partner-btn vortex-partner-btn-secondary"
                                href="#requirements"
                            >

                                Requirements

                            </a>


                        </div>


                    </div>


                </section>







                {/* STATS */}



                <section>


                    <h2 className="vortex-partner-section-title">

                        Our Studio

                    </h2>



                    <div className="vortex-partner-stats">



                        <div className="vortex-partner-stat">

                            <h2>
                                1+
                            </h2>

                            <p>
                                Minecraft Projects
                            </p>

                        </div>





                        <div className="vortex-partner-stat">

                            <h2>
                                30+
                            </h2>

                            <p>
                                Community Players
                            </p>

                        </div>






                        <div className="vortex-partner-stat">

                            <h2>
                                24/7
                            </h2>

                            <p>
                                Development
                            </p>

                        </div>







                        <div className="vortex-partner-stat">

                            <h2>
                                ∞
                            </h2>

                            <p>
                                Creativity
                            </p>

                        </div>




                    </div>


                </section>









                {/* CREATIONS */}



                <section>


                    <h2 className="vortex-partner-section-title">

                        What We Create

                    </h2>




                    <div className="vortex-partner-grid">



                        <div className="vortex-partner-card">


                            <div className="vortex-partner-icon">
                                🌎
                            </div>


                            <h3>
                                Minecraft Worlds
                            </h3>


                            <p>

                                Adventure maps, survival worlds,
                                minigames, and custom experiences
                                built for players.

                            </p>


                        </div>







                        <div className="vortex-partner-card">


                            <div className="vortex-partner-icon">
                                ⚙️
                            </div>


                            <h3>
                                Addons
                            </h3>


                            <p>

                                Custom mobs, items, gameplay systems,
                                and new Minecraft mechanics.

                            </p>


                        </div>








                        <div className="vortex-partner-card">


                            <div className="vortex-partner-icon">
                                🎨
                            </div>


                            <h3>
                                Texture Packs
                            </h3>


                            <p>

                                High quality textures, skins,
                                and visual improvements.

                            </p>


                        </div>



                    </div>


                </section>









                {/* REQUIREMENTS */}




                <section id="requirements">


                    <h2 className="vortex-partner-section-title">

                        Creator Requirements

                    </h2>





                    <div className="vortex-partner-requirement-grid">





                        <ul className="vortex-partner-list">


                            <li>
                                ✔ Original Minecraft content
                            </li>


                            <li>
                                ✔ Good quality standards
                            </li>


                            <li>
                                ✔ Creative mindset
                            </li>


                            <li>
                                ✔ Team communication
                            </li>


                            <li>
                                ✔ Follow Marketplace rules
                            </li>


                        </ul>






                        <div className="vortex-partner-box">


                            <h3>
                                Looking For
                            </h3>


                            <ul className="vortex-partner-list">


                                <li>
                                    Minecraft Builders
                                </li>


                                <li>
                                    Addon Developers
                                </li>


                                <li>
                                    Texture Artists
                                </li>


                                <li>
                                    Map Creators
                                </li>


                            </ul>


                        </div>




                    </div>



                </section>









                {/* PROCESS */}



                <section className="vortex-partner-process">



                    <h2 className="vortex-partner-section-title">

                        Partnership Process

                    </h2>




                    <div className="vortex-partner-steps">



                        <div className="vortex-partner-step">

                            <div className="vortex-partner-number">
                                1
                            </div>


                            <h3>
                                Apply
                            </h3>


                            <p>
                                Send your creator application.
                            </p>

                        </div>






                        <div className="vortex-partner-step">

                            <div className="vortex-partner-number">
                                2
                            </div>


                            <h3>
                                Review
                            </h3>


                            <p>
                                Our team checks your work.
                            </p>

                        </div>







                        <div className="vortex-partner-step">

                            <div className="vortex-partner-number">
                                3
                            </div>


                            <h3>
                                Create
                            </h3>


                            <p>
                                Build amazing Minecraft content.
                            </p>

                        </div>







                        <div className="vortex-partner-step">

                            <div className="vortex-partner-number">
                                4
                            </div>


                            <h3>
                                Publish
                            </h3>


                            <p>
                                Release your creations.
                            </p>

                        </div>



                    </div>


                </section>









                {/* CTA */}




                <section
                    id="apply"
                    className="vortex-partner-cta"
                >


                    <div className="vortex-partner-cta-content">


                        <h2>

                            Become A Vortex Creator

                        </h2>




                        <p>

                            Help us build the future of Minecraft
                            Marketplace content.

                        </p>




                        <button>

                            Start Application

                        </button>



                    </div>


                </section>





            </div>


        </div>

    );

}